import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { UntypedFormGroup, UntypedFormArray, UntypedFormBuilder } from '@angular/forms';
import { Location } from '@angular/common';
import { BaseModalPageComponent } from '../../base-modal.component';
import { ModalComponent } from '../../modal/modal.component';
import { ConfirmComponent } from '../../modal/confirm.component';

import * as _ from 'lodash';
import { InterventionTasksPluginService } from './interventiontasks-plugin.service';

@Component({
    selector: 'interventiontasks-edit',
    templateUrl: './interventiontasks-edit.component.html',
    standalone: false
})
export class InterventionTasksEditPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  pointId: string;
  pluginId: string;
  public plugin: any;
  editForm: UntypedFormGroup;
  public currentItem: any;
  public tasks: any;
  public processing = false;
  @ViewChild('menuModal', { static: true })
  menuModal: ModalComponent;
  @ViewChild('deleteConfirm', { static: true })
  deleteConfirm: ConfirmComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private service: InterventionTasksPluginService,
    location: Location,
    private cdRef: ChangeDetectorRef,
    private fb: UntypedFormBuilder
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.goToBack();

      this.inspectionId = id;

      const pointId = params['pointId'];
      if (pointId == null) this.goToBack();

      this.pointId = pointId;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();

      this.pluginId = pluginId;

      this.initData();
    });
  }

  save(model: any) {
    this.processing = true;
    this.service.updateTasks(this.inspectionId, this.pointId, this.pluginId, model.tasks).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  cancel() {
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
  }

  initData() {
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.tasks = this.plugin.config.Tasks != null ? this.plugin.config.Tasks : [];
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  remove(i: number) {
    const control = <UntypedFormArray>this.editForm.controls['tasks'];
    control.removeAt(i);
  }

  add() {
    const control = <UntypedFormArray>this.editForm.controls['tasks'];
    control.push(this.initTask());
  }

  initTask(el?: any) {
    return this.fb.group({
      Client: el?.Client ?? '',
      Description: el?.Description ?? '',
      Date: el?.Date ?? ''
    });
  }

  initForm() {
    this.editForm = this.fb.group({
      tasks: this.fb.array([])
    });
    const control = <UntypedFormArray>this.editForm.controls['tasks'];
    _.forEach(this.tasks, (el) => {
      control.push(this.initTask(el));
    });
  }

  get formData() {
    return <UntypedFormArray>this.editForm.controls['tasks'];
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
      default:
    }
  }

  gotoEditJsonPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId,
      'plugins',
      this.pluginId,
      'editjson'
    ]);
  }

  gotoEditPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId,
      'plugins',
      this.pluginId,
      'edit'
    ]);
  }

  openDeleteConfirm() {
    this.deleteConfirm.open();
  }

  deletePlugin(e: any) {
    this.service.deletePlugin(this.inspectionId, this.pointId, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }
}
